import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/Contact";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/contact")({
  head: () =>
    seo({
      title: "Contact Cedar Creek Construction | Free Estimates in Minnesota",
      description:
        "Get a free roofing or siding estimate. Call (612) 298-9865, email chuck@cedarcreekconstruct.com, or schedule online. Serving the Minneapolis north metro.",
      path: "/contact",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Contact", path: "/contact" },
      ]),
    }),
  component: Contact,
});
